import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, DisplayMapMarker, inject, Map } from 'Mri.Web.Common';
import * as React from 'react';
import { AppStore } from '../../Core/AppStore';
import { ActiveDisplay } from '../ActiveDisplay';

export interface IDisplayMapCardProps {
    readonly display: ActiveDisplay;
    readonly loading: boolean;
}

@autoinject
@observer
export class DisplayMapCard extends React.Component<IDisplayMapCardProps> {
    public render() {
        const { display, loading } = this.props;
        const lat = display.unitLocation?.latitude ?? 0;
        const lng = display.unitLocation?.longitude ?? 0;

        return (
            <div className="status-list h-100 rounded">
                <div className="text-center h-100 flex-grow-1">
                    <div className="flex-items-center h-100">
                        <Map
                            dark={this.appStore.storage.theme == 'dark-theme'}
                            defaultCenter={{ lat, lng }}
                            zoom={15}
                            disableRefitBounds={true}
                            height="100%"
                            style={{ borderRadius: '0.25rem' }}
                        >
                            <DisplayMapMarker
                                key={display.serialNumber}
                                serialNumber={display.serialNumber}
                                lat={lat}
                                lng={lng}
                                address1={display.unitLocation?.address1}
                                address2={display.unitLocation?.address2}
                                city={display.unitLocation?.city}
                                stateOrProvince={display.unitLocation?.stateOrProvince}
                                country={display.unitLocation?.country}
                                postalCode={display.unitLocation?.postalCode}
                                color={this.color}
                                notification={display.muted}
                            />
                        </Map>
                    </div>
                </div>
            </div>
        );
    }

    @computed
    private get color() {
        switch (this.props.display.videoState) {
            case 'noVideo':
                return 'danger';
            case 'showingVideo':
                return 'good';
            case 'warning':
                return 'warning';
        }
    }

    @inject
    private appStore!: AppStore;
}
